import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { AppointmentService } from '@avanta/shared/services/appointments';
import { type BookingOptions } from '@avanta/shared/types/appointments';

export const useFetchSpecialitiesByPsycho = ({
  psychologistId,
  insurance = false,
  contractId,
  patientId,
}: {
  psychologistId: string;
  insurance?: boolean;
  contractId?: string;
  patientId?: string;
}): UseQueryResult<BookingOptions> =>
  useQuery({
    queryKey: [
      QUERY_KEYS.FETCH_SPECIALITIES_BY_PSYCHO,
      psychologistId,
      insurance,
      contractId,
      patientId,
    ],
    queryFn: () =>
      AppointmentService.getBookingOptionsByPsycho({
        psychologistId,
        insurance,
        contractId,
        patientId,
      }),
    select: response => response.data,
    enabled: !!psychologistId,
  });
